import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import AboutBannerImg1 from '../assets/images/find-your-own-agent.png';
import ArrowIcon from '../assets/images/button-arrow.svg';
const FindYourOwnAgent = () => {
   return (
    <section className="about-banner-section">
        <Row>
           <Col lg={6} md={12}>
            <div className="about-image">
              <img 
                src={AboutBannerImg1}
                alt="Modern House" 
                className="house-img"
              />
            </div>
          </Col>
          <Col lg={6} md={12} className='about-content-box align-self-center'>
            <div className="about-content">
              <h1 className="about-title d-flex align-items-center">Find your own <span>agent</span></h1>
              <ul>
                <li>Explore agents by local market expertise, specialties and verified reviews to
                find the perfect match.</li>
                <li>Already have an agent? See how Real Estate can help you get in front of the most
                buyers to maximize your sale.</li>
                <li>Already have an agent? See how Real Estate can help you get in front of the most
                buyers to maximize your sale.</li>
                <li>Already have an agent? See how Real Estate can help you get in front of the most
                buyers to maximize your sale.</li>
                <li>Already have an agent? See how Real Estate can help you get in front of the most
                buyers to maximize your sale.</li>
              </ul>
              <Button className="custom-bttn style-3 ani-1 right">
                Find an Agent <img src={ArrowIcon} alt="Arrow Icon" />
              </Button>
             
            </div>
          </Col>        
        </Row>
    </section>
  );
}

export default FindYourOwnAgent;